<template>
    <div class="llm_box">
        <div class="llm_box_top">
            <div class="llm_left">
                <div class="d_btn_box">
                    <div class="llm_add" @click="createLlm" v-loading="addLoading">{{ lang.goToNew2 }}</div>
                </div>
            </div>
            <div class="llm_right">
                <span class="list" :class="{ active: stype2 == 1 }" @click="checkStype2(1)"></span>
                <span class="table" :class="{ active: stype2 == 2 }" @click="checkStype2(2)"></span>
            </div>
        </div>
        <div class="card-list" v-if="stype2 == 1 && notes.length" v-loading="isLoading">
            <div class="card" v-for="item in notes" :key="item.id" @click="rowClick(item)">
                <div class="avatar">
                    <img v-if="item.avatar && item.avatar.includes('https')" :src="item.avatar" alt="avatar" class="img" />
                    <span v-else-if="item.avatar" class="img">{{ item.avatar }}</span>
                    <span v-else class="img">😊</span>

                    <div style="margin-left: auto;">
                        <el-popover placement="bottom-start" trigger="hover" popper-class="custom-popover" visible-arrow
                            width="100px">
                            <div class="BtnHP">
                                <div class="BtnHPDel">
                                    <div class="btnBh" @click="rowClick(item)" @mouseover="isHover = true"
                                        @mouseleave="isHover = false">
                                        <img :src="isHover ? look2 : look1" />
                                        <span :class="isHover ? 'lookHp2' : 'lookHp1'">{{
                                            lang.view
                                        }}</span>
                                    </div>
                                </div>
                                <div style="
                                        background-color: #e7e7e7;
                                        width: 100%;
                                        height: 0.5px;
                                        margin: 5px 0;
                                    "></div>
                                <div class="BtnHPDel1">
                                    <div class="btnBh2" @click="deleteFile(item.id)">
                                        <img src="@/assets/img/cocobookllm/listdel.svg" alt="" />
                                        <span style="color: #de4c41">{{ lang.delete }}</span>
                                    </div>
                                </div>
                            </div>

                            <el-button slot="reference" class="BtnH"
                                style="border: none; background: none; padding: 5px">
                                <i class="el-icon-more"></i>
                            </el-button>
                        </el-popover>
                    </div>
                </div>
                <div class="card-content">
                    <div class="title">{{ item.title }}</div>
                    <div class="meta">
                        <span>{{ item.date }}</span>
                        <span>· {{ countFile(item.file) }} {{ lang.Sources }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="notes.length" class="list_file_box" v-loading="isLoading">
            <el-table ref="myTable" :data="notes" border style="width: 100%" max-height="800px"
                :row-key="(row) => row.id" @row-click="rowClick">
                <el-table-column :label="lang.title" prop="title" min-width="400">
                    <template #default="scope">
                        <span class="avatar2">
                            <img v-if="scope.row.avatar && scope.row.avatar.includes('https')" :src="scope.row.avatar" alt="avatar" class="img" />
                            <span v-else-if="scope.row.avatar">{{ scope.row.avatar }}</span>
                            <span v-else>😊</span>
                            <span>{{ scope.row.title }}</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="lang.source_count" min-width="120">
                    <template #default="scope">
                        {{ countFile(scope.row.file) }} {{ lang.source }}
                    </template>
                </el-table-column>
                <el-table-column :label="lang.DateCreated" prop="date" min-width="160" />
                <el-table-column :label="lang.CreatedBy" prop="username" min-width="160">
                </el-table-column>
                <el-table-column label="" width="100px">
                    <template #default="scope">
                        <div>
                            <el-popover placement="bottom-start" trigger="hover" popper-class="custom-popover"
                                visible-arrow width="100px">
                                <div class="BtnHP">
                                    <div class="BtnHPDel">
                                        <div class="btnBh" @click="rowClick(scope.row)" @mouseover="isHover = true"
                                            @mouseleave="isHover = false">
                                            <img :src="isHover ? look2 : look1" />
                                            <span :class="isHover ? 'lookHp2' : 'lookHp1'">{{
                                                lang.view
                                                }}</span>
                                        </div>
                                    </div>
                                    <div style="
                                        background-color: #e7e7e7;
                                        width: 100%;
                                        height: 0.5px;
                                        margin: 5px 0;
                                    "></div>
                                    <div class="BtnHPDel1">
                                        <div class="btnBh2" @click="deleteFile(scope.row.id)">
                                            <img src="@/assets/img/cocobookllm/listdel.svg" alt="" />
                                            <span style="color: #de4c41">{{ lang.delete }}</span>
                                        </div>
                                    </div>
                                </div>

                                <el-button slot="reference" class="BtnH"
                                    style="border: none; background: none; padding: 5px">
                                    <i class="el-icon-more"></i>
                                </el-button>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="ac_c_empty" v-if="notes.length === 0" v-loading="isLoading">
            <div>
                <img src="@/assets/img/appCenter/appManagement/empty_appImg.svg" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

// 导入SVG组件
import look1 from "@/assets/img/cocobookllm/look1.svg";
import look2 from "@/assets/img/cocobookllm/look2.svg";

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    name: 'cocobookLlm',
    components: {
    },
    data() {
        return {
            notes: [],
            stype2: 1,
            look1: look1,
            look2: look2,
            isHover: false,
            addLoading: false,
            isLoading: false,
            emojis: [
                "🙂", "😄", "😁", "😎", "😍", "🥰", "😋", "🤗", "🤩", "😊",
                "👋", "🤚", "✋", "🤙", "👌", "✌️", "🤟", "👈", "👉", "👆", "👇",
                "🐶", "🐱", "🐰", "🦁", "🦊", "🦓", "🦒", "🦄", "🐮", "🐷", "🐸", "🐍", "🐦", "🦉",
                "🍎", "🍌", "🍍", "🍓", "🍉", "🍇", "🍕", "🍔", "🍣", "🍟", "🍩", "🥧", "🍺", "🥤",
                "🚗", "🚕", "🚙", "🚌", "🚎", "🚓", "🚑", "🚒", "🚐", "🚜", "🛻", "🚲", "🚎",
                "🌞", "🌧️", "❄️", "🌈", "⛅", "🌪️", "🌩️", "🌨️", "🌫️", "🌊",
                "🎉", "🎊", "🎁", "🎂", "🕯️", "🎄", "🎃", "🎆", "🎇", "🧨",
                "⚽", "🏀", "🏈", "🎾", "🏐", "🏉", "🎱", "🎳", "🏓", "🏸", "⛷️",
                "🖥️", "📱", "🖨️", "🖋️", "💻", "🧳", "📦", "🛋️", "🛏️", "🕰️",
                "💖", "💗", "💕", "💙", "💛", "💚", "💜", "🧡", "🤍", "🤎"
            ],
        };
    },
    computed: {
        countFile() {
            return function(str) {
                try {
                    const count = str ? JSON.parse(str).length : 0;
                    return count;
                } catch (error) {
                    console.error('Error parsing JSON string:', error);
                    return 0;
                }
            };
        }
    },
    methods: {
        // 在这里定义你的方法
        checkStype2(type) {
            if (this.stype2 != type) {
                this.stype2 = type;
            }
        },
        rowClick(item) {
            this.$router.push({ path: '/cocobookllmDetail', query: { id: item.id } })
        },
        deleteFile(id) {
            this.$confirm(this.lang.comfim_delete, this.lang.tip, {
                confirmButtonText: this.queding,
                cancelButtonText: this.cancel,
                type: "warning",
            })
            .then(async () => {
                let params = {
                    id
                }
                this.ajax
                    .post(this.$store.state.api + 'delete_llm', [params])
                    .then(() => {
                        this.$message.success(this.lang.delete_cg)
                        this.getData()
                    })
                    .catch((e) => {
                        this.$message.success(this.lang.deletion_failure)
                        console.log(e);
                    });
            })
            .catch(() => { });
        },
        getData: _.debounce(function(type) {
            if(this.isLoading){
                return
            }
            this.notes = type == 2 ? this.notes : []
            this.isLoading = true
            let params = {
                uid: this.user.userId,
            }
            this.ajax
              .get(this.$store.state.api + 'get_all_llm', params)
              .then((res) => {
                this.isLoading = false
                console.log(res);
                // 格式化数据里面的date
                this.notes = res.data[0].map(item => {
                  if (item.date) {
                    // 假设date是时间戳或ISO字符串，根据实际情况格式化
                    const dateObj = new Date(item.date);
                    // 格式化为 yyyy-MM-dd HH:mm:ss
                    const yyyy = dateObj.getFullYear();
                    const MM = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const dd = String(dateObj.getDate()).padStart(2, '0');
                    const hh = String(dateObj.getHours()).padStart(2, '0');
                    const mm = String(dateObj.getMinutes()).padStart(2, '0');
                    const ss = String(dateObj.getSeconds()).padStart(2, '0');
                    item.date = `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
                  }
                  return item;
                });
            })
              .catch((e) => {
                this.isLoading = false
                console.log(e);
              });
        }, 300),
        getRandomEmoji() {
            // 随机选择一个 emoji
            const randomIndex = Math.floor(Math.random() * this.emojis.length);
            return this.emojis[randomIndex];
        },
        createLlm() {
            if(this.addLoading){
                return
            }
            this.addLoading = true
            let params = {
                userid: this.user.userId,
                title: this.lang.unnamedNote,
                a: this.getRandomEmoji(),
                t2: this.lang.chat2,
            }
            this.ajax
              .post(this.$store.state.api + 'add_llm', [params])
              .then((res) => {
                this.addLoading = false
                this.getData()
                console.log(res);
                this.$message.success(this.lang.addSuccessfully2)
                this.rowClick(res.data[0][0])
              })
              .catch((e) => {
                this.addLoading = false
                this.$message.success(this.lang.addFailure2)
                console.log(e);
              });
        }
    },
    activated(){
        this.getData(2)
    },
    mounted() {
        // 在这里编写你的mounted生命周期函数
        this.getData()
    },
};
</script>

<style scoped>
/* 在这里编写你的样式 */
.llm_box {
    height: 100%;
    width: 100%;
    padding: 24px;
    /* background: #f5faff; */
    background-image: url("@/assets/img/appCenter/background2.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    overflow: auto;
}

.card-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}

.card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 20px;
    cursor: pointer;
    transition: box-shadow 0.2s;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.avatar {
    display: flex;
    align-items: flex-start;
}

.avatar .img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-bottom: 12px;
    font-size: 32px;
}

.card-content .title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.card-content .meta {
    color: #00000066;
    font-size: 12px;
}

.llm_box_top {
    width: 100%;
    display: flex;
    align-items: center;
    height: 50px;
    margin-bottom: 10px;
}

.llm_box_top .llm_left {
    display: flex;
    align-items: center;
}

.llm_box_top .llm_right {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.llm_box_top .llm_right>span {
    height: 35px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    transition: all .3s;
}

.llm_box_top .llm_right>span+span {
    margin-left: 10px;
}

.llm_box_top .llm_right>span.active {
    background: #e0eafb;
}

.llm_box_top .llm_right>span::before {
    content: "";
    width: 15px;
    height: 15px;
    background-size: 100% 100%;
}

.llm_box_top .llm_right>span.list::before {
    background-image: url("@/assets/img/cocobookllm/test_list.png");
}

.llm_box_top .llm_right>span.table::before {
    background-image: url("@/assets/img/cocobookllm/test_table.png");
}

.llm_box_top .llm_right>span.table.active::before {
    background-image: url("@/assets/img/cocobookllm/test_table_active.png");
}

.llm_box_top .llm_right>span.list.active::before {
    background-image: url("@/assets/img/cocobookllm/test_list_active.png");
}



.list_file_box {
    width: 100%;
}

.list_file_box>>>.el-table {
    /* border-radius: 10px !important; */
    overflow: hidden !important;
}

.list_file_box>>>table th {
    border: none !important;
    background-color: #fff !important;
    /* 浅灰色背景 */
    color: #00000099 !important;
}

.list_file_box>>>table tr td {
    border: none !important;
    border-bottom: 1px solid #ebeef5 !important;
}

.list_file_box>>>table tr {
    border: 1px #000 solid !important;
}

.list_file_box>>>.el-table__header-wrapper {
    /* margin-bottom: 10px !important; */
    border-bottom: 1px solid #ebeef5;
}

.list_file_box>>>.el-table__row {
    border: 1px #ccc solid;
    cursor: pointer;
}

.list_file_box>>>table tr td:nth-child(1) {
    /* border-radius: 10px 0 0 10px !important; */
}

.list_file_box>>>table tr td:nth-last-child(1) {
    /* border-radius: 0 10px 10px 0 !important; */
}

.list_file_box>>>table tr th:nth-child(1) {
    /* border-radius: 10px 0 0 10px; */
}

.list_file_box>>>table tr th:nth-last-child(2) {
    /* border-radius: 0 10px 10px 0 !important; */
}

.list_file_box>>>.el-table::before {
    background-color: #fff;
}

.list_file_box>>>.el-table--border::after {
    background-color: #fff;
}

.list_file_box>>>.el-table--border {
    border: none;
    border-bottom: 1px solid #ebeef5;
}

/* 标题列头像与文字对齐 */
.list_file_box .avatar2 {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 18px;
    justify-content: flex-start;
    gap: 8px;
}

.list_file_box .avatar2 .img {
    width: 25px;
    height: 25px;
    object-fit: contain;
}

.list_file_box>>>.el-table,
.el-table__expanded-cell {
    background-color: unset;
}

.list_file_box>>>table {
    text-align: unset;
    border-spacing: 0;
    border-left: none;
    border-bottom: none;
    width: 100% !important;
}

.list_file_box>>>table td,
table th {
    border-top: none;
    border-right: none;
    padding: 15px 0;
}

.BtnH>>>.el-button {
    padding: 5px !important;
    width: 30px !important;
    color: #4c5567;
}

.BtnH>>>.el-button:focus,
.BtnH>>>.el-button:hover {
    background: #e8ebf0 !important;
    color: #487fff !important;
}

.BtnH>>>.el-button--small,
.el-button--small.is-round {
    border: none;
    padding: 0;
}

.BtnHP {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.BtnHP>>>.el-button:focus,
.BtnHP>>>.el-button:hover {
    background-color: #487fff;
}

.BtnHP>>>.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
    display: none;
}

.BtnHP>>>.el-button--text {
    color: #667095;
}

.BtnHP img {
    width: 16px;
}

/* 删除 */
.BtnHPDel1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #de4c41 !important;
}

.BtnHPDel1>>>.el-button:focus,
.BtnHPDel1>>>.el-button:hover {
    background: #fbeae8;
    color: #de4c41 !important;
}

.BtnHPDel {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
}

.BtnHPDel>>>.el-button+.el-button {
    padding: 0;
}

.BtnHPDel>>>.el-button:focus,
.BtnHPDel>>>.el-button:hover {
    background: #e8ebf0 !important;
}

.lookHp2 {
    color: #6c6c6c;
}

.lookHp2 {
    color: #487fff;
}

.btnBh:hover {
    background: #f0f4ff;
}

.btnBh img {
    margin-right: 5px;
    width: 17px;
}

.btnBh2 img {
    width: 17px;
    margin-right: 5px;
    padding: 1.5px;
    box-sizing: border-box;
}

.btnBh2:hover {
    background: #fbeae8;
}

.btnBh2 {
    display: flex;
    /* align-items: center; */
    cursor: pointer;
    padding: 5px 8px;
    border-radius: 6px;
    box-sizing: border-box;
}

.btnBh {
    display: flex;
    cursor: pointer;
    border-radius: 6px;
    padding: 5px 8px;
}


.d_btn_box>div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    height: 40px;
    min-height: 40px;
    border: 1px solid #202020;
    color: #fff;
    cursor: pointer;
    transition: all .3s;
    gap: 8px;
    padding: 0 15px;
    font-size: 14px;
    background: #202020;
}


.d_btn_box>div:hover {
    background: #000;
    border: 1px solid #000;
}

.d_btn_box .llm_add::before {
    content: "";
    display: block;
    width: 15px;
    height: 15px;
    cursor: pointer;
    background-image: url('@/assets/img/cocobookllm/add_fff.svg');
    background-size: 100% 100%;
}


.ac_c_empty {
    width: 100%;
    height: 40%;
    display: flex;
    box-sizing: border-box;
    /* padding-top: 2%; */
    justify-content: center;
    color: #a1a1a1;

    /* align-items: center; */
}

.ac_c_empty div {
    width: 5vw;
    height: 5vw;
    min-width: 100px;
    min-height: 100px;
    margin-top: 50px;

}

.ac_c_empty div img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>

<style>
.custom-popover {
    min-width: 70px !important;
    width: auto !important;
    padding: 8px 6px;
    border-radius: 8px;
}

/* .custom-popover2 {
  min-width: 18px !important;
  width: auto !important;
  padding: 8px;
  top: 414px !important;
  text-align: center;
} */

</style>
